module.exports = __webpack_public_path__ + "img/AdobeStock_240411596.jpeg";